export enum EQueryKeys {
  MedicalSpecialties = 'medical-specialties',
  MedicationDetails = 'medication-details',
  Medications = 'medications',
  MyMedicationCreates = 'my-medication-creates',
  MyMedicationUpdates = 'my-medication-updates',
  MyStatements = 'my-statements',
  MyTreatmentCreates = 'my-treatment-creates',
  MyTreatmentUpdates = 'my-treatment-updates',
  NewMedicationDetails = 'new-medication-details',
  NewMedications = 'new-medications',
  NewTreatmentDetails = 'new-treatment-details',
  NewTreatments = 'new-treatments',
  Session = 'session',
  TreatmentDetails = 'treatment-details',
  Treatments = 'treatments',
}
